import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import * as moment from 'moment';

@Component({
  selector: 'app-period',
  templateUrl: './period.component.html',
  styleUrls: ['./period.component.scss']
})
export class PeriodComponent implements OnInit {

  @Output() myDates = new EventEmitter();
  @Input() default:any;
  @Input() showDates:boolean = true;

  range:any;

  periods = [
    {label:"Aujourd'hui", value: {min:moment().format("YYYY-MM-DD"),max:moment().format("YYYY-MM-DD")}},
    {label:"Mois courant", value:{min:moment().format("YYYY-MM-01"),max:moment().format("YYYY-MM-DD")}},
    {label:"Année courante", value:{min:moment().format("YYYY-01-01"),max:moment().format("YYYY-MM-DD")}},
    {label:"Hier", value:{min:moment().subtract(1, 'days').format("YYYY-MM-DD"),max:moment().subtract(1, 'days').format("YYYY-MM-DD")}},
    {label:"Mois -1", value:{min:moment().subtract(1, 'months').startOf('month').format("YYYY-MM-DD"),max:moment().subtract(1, 'months').endOf('month').format("YYYY-MM-DD")}},
    {label:"Année -1", value:{min:moment().subtract(1, 'years').startOf('years').format("YYYY-MM-DD"),max:moment().subtract(1, 'years').endOf('years').format("YYYY-MM-DD")}},
  ]

  period:any;

  constructor() {}

  ngOnInit(): void {
    this.period = this.periods[this.default].value;
    this.refresh();
  }
  
  refresh(){
    if(this.period){
      this.range = [new Date(this.period.min),new Date(this.period.max)];
      this.myDates.emit(this.period);
    }
  }

  chooseDates(){
    this.period = {
      min: moment(this.range[0]).format("YYYY-MM-DD"),
      max: moment(this.range[1]).format("YYYY-MM-DD")
    };
    if(this.range[0] != null && this.range[1] != null)
      this.refresh();
  }
}
